module.exports = __webpack_public_path__ + "img/logo.0d645034.png";